import React, { useState, useEffect } from "react";
import { Typography } from "@mui/material";
import Div from "@jumbo/shared/Div";
import RenderHTML from "components/RenderHTML";
import Divider from "@mui/material/Divider";
import SkeletonCard from "components/Skeleton";
import JumboCardQuick from "@jumbo/components/JumboCardQuick";
import CodeIcon from "@mui/icons-material/Code";
import { StyledTab, StyledTabs } from "components/CustomTabs";
import { TabPanel } from "components/TabPanel";
import JumboCodeBlock from "@jumbo/components/JumboCodeBlock";
import { HEIGHT_OFFSET } from "app/utils/constants/constants";

const EditorialTab = ({ problemData, loading, isPanelOpen }) => {
  const [codeTabs, setCodeTabs] = useState([]);

  useEffect(() => {
    if (problemData?.problemTranslations?.[0]?.algorithmTranslations) {
      setCodeTabs(
        new Array(
          problemData.problemTranslations[0].algorithmTranslations.length
        ).fill(0)
      );
    }
  }, [problemData]);

  const handleCodeTabChange = (index, newValue) => {
    setCodeTabs((prev) => prev.map((tab, i) => (i === index ? newValue : tab)));
  };

  return problemData?.problemTranslations &&
    problemData?.problemTranslations[0] ? (
    <Div
      sx={{
        p: 2,
        height: `calc(100vh - ${HEIGHT_OFFSET.DEFAULT})`,
        overflowY: "auto",
        overflowX: "hidden",
      }}
    >
      {problemData?.problemTranslations[0].algorithmTranslations?.map(
        (eachTranslation, translationIndex) => (
          <Div key={translationIndex}>
            <RenderHTML
              htmlContent={eachTranslation?.algorithmName}
              variant="h3"
            />
            <Divider sx={{ my: 2 }} />
            <RenderHTML htmlContent={eachTranslation?.algorithm} />
            <JumboCardQuick
              sx={{
                mt: 2,
                color: "common.white",
                border: "1px solid #333240",
                borderTop: "4px solid #333240",
              }}
            >
              <Div
                sx={{
                  borderBottom: 1,
                  borderColor: "divider",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <StyledTabs
                  value={codeTabs[translationIndex] || 0}
                  onChange={(event, newValue) =>
                    handleCodeTabChange(translationIndex, newValue)
                  }
                  variant="scrollable"
                  scrollButtons="auto"
                  sx={{ flexGrow: 1 }}
                >
                  {eachTranslation &&
                    eachTranslation?.problemCodeSnippets?.map(
                      (eachCode, id) => (
                        <StyledTab
                          key={id}
                          icon={<CodeIcon />}
                          iconPosition="start"
                          label={
                            eachCode.programmingLanguage
                              ? eachCode.programmingLanguage
                                  .charAt(0)
                                  .toUpperCase() +
                                eachCode.programmingLanguage
                                  .slice(1)
                                  .toLowerCase()
                              : "Unknown"
                          }
                          isPanelOpen={isPanelOpen}
                        />
                      )
                    )}
                </StyledTabs>
              </Div>
              {eachTranslation?.problemCodeSnippets?.map((eachCode, id) => (
                <TabPanel
                  key={id}
                  value={codeTabs[translationIndex] || 0}
                  index={id}
                >
                  {eachCode && (
                    <JumboCodeBlock
                      text={eachCode.codeSnippet}
                      language={eachCode.programmingLanguage.toLowerCase()}
                    />
                  )}
                </TabPanel>
              ))}
            </JumboCardQuick>
            <br />
          </Div>
        )
      )}
    </Div>
  ) : loading ? (
    <SkeletonCard width="80%" count={3} height={50} />
  ) : (
    <Typography variant="h6" sx={{ textAlign: "center", m: "100px auto" }}>
      No data available
    </Typography>
  );
};

export default EditorialTab;
